import context, { HttpMethod } from '@truckdown/systems';
import { UserContext } from '@truckdown/systems/Context/UserContext';
import { defineComponent, ref, Ref, onMounted, computed, onUnmounted } from 'vue';
import { Constants } from '../../constants';

interface IProps {
    enableDismiss: boolean
}

interface IData {
    progressPercent: Ref<number>;
}

const getProgressPercent = function (): number {
    if (context.isInRole("General Admin") && !context.isInRole("Fleet User")) {
        if (context.settings["fleet_onboarding"] == "vendors") {
            return 75;
        } else if (context.settings["fleet_onboarding"] == "favorites") {
            return 50;
        } else if (context.settings["fleet_onboarding"] == "team") {
            return 25;
        }
    }
    return 0;
}

const refreshContextData = function (data: IData) {
    data.progressPercent.value = getProgressPercent();
}

const getData = function () {
    let data = {
        progressPercent: ref<number>(0)
    } as IData;

    refreshContextData(data);
    return data;
}

const getComputed = function (data: IData) {
    return {
        progressTitle: computed(() => {
            if (data.progressPercent.value == 0) {
                return 'Set up Your Account';
            }
            return 'Complete Your Account Setup';
        })
    }
}

const getMethods = function (props: IProps, data: IData) {
    return {
        dismissAccountSetup: async function (evt: Event) {
            if (props.enableDismiss) {
                try {
                    let req = context.apiManager.createRequest({
                        service: 'main',
                        method: HttpMethod.DELETE,
                        path: '/systems/dismiss-onboarding',
                    });
                    var res = await context.apiManager.get<any>(req);

                    if (res) {
                        let val = JSON.stringify(res);
                        let newContext = new UserContext(context.antiforgeryToken, val);

                        context.settings = newContext.settings;
                        context.claims = newContext.claims;
                        context.user = newContext.user;
                        context.authToken = newContext.authToken;
                        refreshContextData(data);
                        context.events.emit("refresh_onboarding_progress");
                    }
                }
                catch (err) {
                    console.log(err);
                }
            }
        }
    }
}

export default defineComponent({
    name: 'setup-progress',
    props: {
        enableDismiss: Boolean
    },
    setup: function (props: IProps) {
        const data = getData();
        const computed = getComputed(data);
        const methods = getMethods(props, data);

        const refreshContext = function () {
            refreshContextData(data);
        }

        onMounted(() => {
            if (context.isAuthenticated) {
                context.events.on(Constants.Events.RefreshOnboardingProgress, refreshContext);
            }
        });

        onUnmounted(() => {
            context.events.off(Constants.Events.RefreshOnboardingProgress, refreshContext);
        });

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});


